import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

const Footer = () => {
  return (
    <footer className="bg-foreground text-primary-foreground py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
          {/* Logo & Brand */}
          <div className="md:col-span-2">
            <img src={logo} alt="Funzy Feets" className="h-20 w-auto mb-4" width={80} height={80} loading="lazy" decoding="async" />
            <p className="text-primary-foreground/70 max-w-sm leading-relaxed">
              Transform your favorite memories into cozy, wearable comfort. 
              Every pair tells your unique story.
            </p>
          </div>

          {/* Collections */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4">Collections</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/collections" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                All Collections
              </Link>
              <Link to="/collections/animals" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Pet & Animal Slippers
              </Link>
              <Link to="/collections/holiday" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Holiday Slippers
              </Link>
              <Link to="/collections/fun" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Fun & Quirky Slippers
              </Link>
              <Link to="/collections/home" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Home Slippers
              </Link>
            </nav>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/models" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                All Models
              </Link>
              <Link to="/product/custom" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Custom Slippers
              </Link>
              <Link to="/faq" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                FAQ
              </Link>
              <Link to="/about" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                About Us
              </Link>
              <Link to="/shipping" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Shipping Policy
              </Link>
            </nav>
          </div>

          {/* Legal & Contact */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4">Legal</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/terms" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                Contact Us
              </Link>
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/10 text-center text-primary-foreground/50 text-sm">
          <p>© {new Date().getFullYear()} Funzy Feets. All rights reserved. Made with love for cozy feet everywhere.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
